import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// CSS real do build de produção (reset + variáveis + classes + todas as animações).
// É a mesma folha de estilo do site publicado, garantindo fidelidade visual.
import "./styles/site-real.css";
import "./styles/blog.css";

// Fontes (Plus Jakarta Sans + IBM Plex Mono) carregadas em public/index.html.
// Tema claro (o build real usa data-theme="light" no root).
document.documentElement.dataset.theme = "light";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
